<template>
  <div class="flight-search-module">
    <div v-if="!showStatus" class="journey-type-container">
      <radio
        name="journey-type"
        label="Round Trip"
        v-model="journeyType"
        :value="tripType.roundTrip"
        class="margin-right-x2 margin-bottom"
      />
      <radio
        label="One Way"
        name="journey-type"
        v-model="journeyType"
        :value="tripType.oneWay"
        class="margin-right-x2 margin-bottom"
      />
      <radio
        label="Multi-City"
        name="journey-type"
        v-model="journeyType"
        :value="tripType.multiCity"
        class="margin-right-x2 margin-bottom"
      />
    </div>
    <div class="row">
      <div class="col-md-6">
        <station-dropdown
          :options="od"
          label="Origin"
          v-model="origin1"
          :validate="doValidate"
          :required="!showStatus"
          :image="images.takeOff"
          :country-map="countryMap"
          @validated="setValidationResult('origin1', $event)"
        />
      </div>
      <div class="col-md-6">
        <station-dropdown
          label="Destination"
          :validate="doValidate"
          v-model="destination1"
          :required="!showStatus"
          :image="images.landing"
          :options="arrStations1"
          :country-map="countryMap"
          @validated="setValidationResult('destination1', $event)"
        />
      </div>
    </div>
    <div class="row" v-if="journeyType === tripType.multiCity">
      <div class="col-md-6">
        <station-dropdown
          label="Origin"
          v-model="origin2"
          :required="!showStatus"
          :validate="doValidate"
          :image="images.takeOff"
          :country-map="countryMap"
          :options="originStations2"
          @validated="setValidationResult('origin2', $event)"
        />
      </div>
      <div class="col-md-6">
        <station-dropdown
          :required="!showStatus"
          label="Destination"
          :validate="doValidate"
          v-model="destination2"
          :image="images.landing"
          :options="arrStations2"
          :country-map="countryMap"
          @validated="setValidationResult('destination2', $event)"
        />
      </div>
    </div>
    <div class="row">
      <div :class="journeyType === tripType.oneWay ? 'col-md-12' : 'col-md-6'">
        <icon-datepicker
          :min="minDate"
          :max="maxDate"
          :image="images.date"
          :validate="doValidate"
          :label="startDateText"
          :required="!showStatus"
          v-model="bookingDateStart"
          @validated="setValidationResult('bookingDateStart', $event)"
        />
      </div>
      <div v-show="journeyType !== tripType.oneWay" class="col-md-6">
        <icon-datepicker
          :required="!showStatus"
          :label="endDateText"
          :image="images.date"
          :validate="doValidate"
          :max="maxDate"
          :min="bookingDateStart"
          v-model="bookingDateEnd"
          @validated="setValidationResult('bookingDateEnd', $event)"
        />
      </div>
    </div>
    <div v-if="showStatus" class="row">
      <dropdown
        class="col-md-6"
        :required="!showStatus"
        v-model="status"
        :inlineLabel="true"
        :validate="doValidate"
        label="Flight Status"
        :options="flightStatus"
        :leftIcon="images.oneWayFlight"
        @validated="setValidationResult('status', $event)"
      />
    </div>
    <slot name="passenger-info"></slot>
    <div class="row">
      <ttw-button value="Search" @click="search" class="col-md-12" />
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { mapState } from "vuex";
import images from "../core/images";
import { toKeyValueArray } from "../core/tools";
import ValidationManager from "../components/base/validation-manager";
import IconDatepicker from "../components/base/input/IconDatepicker";
import { tripType, flightStatus, flightStatusMap } from "../core/enum";
export default {
  inheritAttrs: false,
  mixins: [ValidationManager],
  name: "flight-search-module",
  components: {
    IconDatepicker,
  },
  props: {
    stations: {
      type: Object,
      required: true,
    },
    showStatus: {
      type: Boolean,
      default: false,
    },
    dateStart: {
      default: () => moment().format("YYYY-MM-DD"),
    },
    maxDate: {
      default: () => moment().add(2, "years").format("YYYY-MM-DD"),
    },
  },
  created() {
    this.emitChange();
  },
  data() {
    return {
      origin1: null,
      origin2: null,
      arrStations1: {},
      arrStations2: {},
      destination1: null,
      destination2: null,
      originStations2: {},
      status: flightStatus.all,
      journeyType: tripType.roundTrip,
      bookingDateStart: this.dateStart,
      bookingDateEnd: moment(this.dateStart)
        .add(3, "days")
        .format("YYYY-MM-DD"),
    };
  },
  methods: {
    search() {
      this.commit(() => this.$emit("search", this.getOutput()));
    },
    getFilterOd(station) {
      let obj = {};
      let od = this.od;
      let keys = Object.keys(od);
      let currentStation = this.stationInfo[station];
      if (
        station &&
        currentStation &&
        keys.length > 0 &&
        currentStation.markets
      ) {
        keys.forEach((c) => {
          if (od[c].length > 0) {
            od[c].forEach((s) => {
              if (currentStation.markets.indexOf(s.code) !== -1) {
                if (!obj[c]) {
                  obj[c] = [];
                }
                obj[c].push(s);
              }
            });
          }
        });
      }
      return obj;
    },
    getOutput() {
      return {
        status: this.status,
        origin1: this.origin1,
        origin2: this.origin2,
        journeyType: this.journeyType,
        destination1: this.destination1,
        destination2: this.destination2,
        bookingDateEnd: this.bookingDateEnd,
        bookingDateStart: this.bookingDateStart,
      };
    },
    emitChange() {
      let output = this.getOutput();
      this.$emit("input", output);
      this.$emit("change", output);
    },
  },
  watch: {
    status: "emitChange",
    journeyType: "emitChange",
    destination1: "emitChange",
    destination2: "emitChange",
    bookingDateEnd: "emitChange",
    origin1(val) {
      let stations = this.getFilterOd(val);
      this.destination1 = null;
      this.arrStations1 = stations;
      this.originStations2 = stations;
      this.emitChange();
    },
    origin2(val) {
      let stations = this.getFilterOd(val);
      this.destination2 = null;
      this.arrStations2 = stations;
      this.emitChange();
    },
    bookingDateStart(val) {
      if (this.journeyType === tripType.oneWay) {
        this.bookingDateEnd = val;
      } else {
        let currentTime = new Date(val).getTime();
        let bookingDateEnd = new Date(this.bookingDateEnd).getTime();
        if (currentTime > bookingDateEnd) {
          this.bookingDateEnd = moment(val).add(3, "days").format("YYYY-MM-DD");
        }
        let dates = [moment(this.bookingDateEnd)];
        if (this.maxDate) {
          dates.push(moment(this.maxDate));
        }
        this.bookingDateEnd = moment.min(dates).format("YYYY-MM-DD");
      }

      this.emitChange();
    },
  },
  computed: {
    images: () => images,
    tripType: () => tripType,
    flightStatus: () => toKeyValueArray(flightStatusMap),
    startDateText() {
      return this.showStatus ? "Booking Date" : "Departing On";
    },
    endDateText() {
      return this.showStatus ? "Booking Date To" : "Returning On";
    },
    minDate() {
      let mo = this.showStatus ? moment().add(-10, "years") : moment();
      return mo.format("YYYY-MM-DD");
    },
    stationInfo() {
      let obj = {};
      let od = this.od;
      let keys = Object.keys(od);
      if (keys.length !== 0) {
        keys
          .map((k) => od[k])
          .reduce((prev, current) => prev.concat(current))
          .forEach((x) => (obj[x.code] = x));
      }
      return obj;
    },
    od() {
      let obj = {};
      let keys = Object.keys(this.stations);
      if (keys.length !== 0) {
        Object.entries(this.stations).forEach(
          (x) => (obj[x[0]] = Object.entries(x[1]).map((y) => y[1]))
        );
      }
      return obj;
    },
    ...mapState({
      countryMap: (s) => {
        let obj = {};
        Object.entries(s.countries).forEach((x) => (obj[x[0]] = x[1].name));
        return obj;
      },
    }),
  },
};
</script>
<style scoped lang="scss">
.flight-search-module {
  hr {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  .journey-type-container {
    margin-bottom: 1rem;
  }
  .row {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    > div {
      padding-left: 0.5rem;
      padding-right: 0.5rem;
    }
  }
}
</style>